import s from './index.module.css'
import style from '../../index.module.css'
import commonStyle from '../Common/common.module.css'
import UploadFile from '../../../../../UI/UploadFile'
import { ButtonAdd, ButtonRemove } from '../Common/Buttons'
import { useEffect, useState } from 'react'
import { homeTaskApi } from '../../../../../../api'
import { Input } from 'antd'

export const ImagesDrawing = ({ data, edit }) => {
  const [fileList, setFilterList] = useState(data?.homeTaskFiles?.filter(item => item.type === 'image-drawing'))

  const removeFile = id => homeTaskApi.removeFile(id).then(res => {
    if (res.data.status === 'success') setFilterList(prev => [...prev.filter(item => item.id !== id)])
  })

  const add = () => edit(prev => ({ ...prev, images_drawing: [...prev.images_drawing, { file: {}, size: 100 }] }))
  
  useEffect(() => {
      if(!fileList?.length && !data.images_drawing?.length){
        edit(prev => ({ ...prev, images_drawing: [...prev.images_drawing, { file: {}, size: 100 }] }))
      }
  }, [fileList, data.images_drawing])
  console.log(data)
  const remove = i => edit(prev => ({ ...prev, images_drawing: [...prev.images_drawing.filter((_, index) => index !== i)] }))
  const input = (val, i) => edit(prev => ({
    ...prev, images_drawing: [...prev.images_drawing?.map((item, index) => ((i === index) ? { ...item, file: val } : item))]
  }))
  const updateSize = ({e, id, index}) => {
    let value = e.target.value;
    if (value === '' || Number(value) >= 1) {
      const newValue = value === '' ? '' : Math.min(100, Number(value));
      console.log(newValue)
      if(id){
        edit(prev => ({
          ...prev, homeTaskFiles: [...prev.homeTaskFiles?.map((item) => ((item.id === id) ? { ...item, size: newValue } : item))]
        }))
      }
      else if(index || index === 0){
        edit(prev => ({
          ...prev, images_drawing: [...prev.images_drawing?.map((item, i) => ((index === i) ? { ...item, size: newValue } : item))]
        }))
      }
    }
  }

  return <div className={s.wrapper}>
    <span className={style.heading}>Изображение для рисования:</span>
    <div className={s.list}>
      {fileList?.map((item, index) =>
        <Item
          key={index}
          index={index}
          value={item.file_path}
          input={input}
          showMode={true}
          remove={() => removeFile(item.id)}
          size={item?.size}
          setSize={(e)=> updateSize({e, id: item.id})}
        />
      )}
      {data.images_drawing?.map((item, index) =>
        <Item
          key={index}
          index={index}
          value={item.file}
          input={input}
          remove={() => remove(index)}
          size={item?.size}
          setSize={(e)=> updateSize({e, index})}
        />
      )}
       {/* <ButtonAdd onClick={add} /> */}
    </div>
  </div>
}

const Item = ({ index, value, input, remove, showMode = false, size, setSize }) => {
  return <div className={s.row}>
    <UploadFile className={commonStyle.file} value={value} onChange={val => input(val, index)} showMode={showMode} />
    <ButtonRemove onClick={remove} />

    <div className={s.setSizeWpapper}>
        <span className={s.sizeSpan}>Размер</span>
        <div className={s.sizeContainer}>
          <Input
            type="number"
            className={s.sizeInput}
            value={size}
            onChange={setSize}
            min="1"
            max="100"
            step="1"
          />
          <span>%</span>
        </div>
      </div>
  </div>
}
